module.exports = __webpack_public_path__ + "img/default_image_product.197df554.svg";